<template>
	<!-- <div ref="canvas" :class="{'banner':true,'banner_canvas':showCanvas}"> -->
	<div ref="canvas" :class="{'banner_canvas':showCanvas}">
		<!-- 页头 -->
		<Header></Header>
		<!-- 首页轮播 -->
		<Banner></Banner>
	</div>
</template>

<script>
	import Header from './Header.vue';
	import Banner from './Banner.vue';
	import CanvasParticle from '../../public/js/canvas-particle.js';
	export default {
		name: 'CanvasParticle',
		props: {
			//是否显示Canvas
			showCanvas: {
				type: Boolean, //类型也可以是多样 比如：String||Number
				required: true,
				default: () => {
					return false;
				}
			}
		},
		components: {
			Header,
			Banner
		},
		mounted: function() {
			// this.$nextTick(() => {
			let elemCvHeight = window.innerWeight || document.documentElement.clientHeight || document.body.clientHeight; //获取设备可用区域高度
			this.$refs["canvas"].style.height = elemCvHeight + "px"; //设定Canvas高度
			//拖拽动画效果图 canvas
			var config = {
				vx: 4,
				vy: 4,
				height: 3,
				width: 3,
				count: 100,
				color: "56,153,255",
				stroke: "100,200,180",
				dist: 6000,
				e_dist: 20000,
				max_conn: 10
			}
			CanvasParticle(config);
			this.$emit("SetShowCanvas", true); //修改父组件的属性
			// });
		}
	}
</script>

<style>
</style>
